import React from 'react'
import { SpinnerProps } from './types'
import './index.scss'

export const Spinner: React.FC<SpinnerProps> = ({ size, background, className }) => {
  return (
    <svg
      data-testid={`${background}-spinner-${size}`}
      className={`ds-spinner ${size ? 'ds-spinner-' + size : ''} ${className ?? ''}`}
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg">
      <circle className="ds-spinner-background" cx="33" cy="33" r="30"></circle>
      <circle className={`ds-spinner-circle ${background ? 'ds-spinner-circle-' + background : ''}`} cx="33" cy="33" r="30"></circle>
    </svg>
  )
}
